'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var SelectList_module = require('./SelectList.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const SelectList = _ref => {
  let {
    className = '',
    s = {},
    value,
    defaultValue,
    disabled = false,
    onChange,
    onFocus,
    onBlur,
    children
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("select", {
    className: clsx.clsx({
      [SelectList_module["default"].select]: true,
      [SelectList_module["default"].selectDisabled]: disabled,
      [className]: true
    }),
    style: s,
    defaultValue: value || defaultValue,
    disabled: disabled,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur
  }, children);
};

exports["default"] = SelectList;
